export default __webpack_public_path__ + "static/media/brand4.baf92111.svg";